import { Box, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

import { appBackgroundColor } from "../../theme";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        height: "400px",
        position: "relative",
        width: "100%",
        // borderTop: "1px solid #e5e7eb",
        py: 10,
        px: { xs: 3, md: 4 },
        mt: "200px",
        overflow: "hidden",
        bgcolor: appBackgroundColor,
      }}
    >
      {/* Giant background "loops" watermark */}
      <Typography
        aria-hidden
        sx={{
          position: "absolute",
          bottom: { xs: -40, md: -60 },
          left: { xs: -20, md: 0 },
          right: 0,
          textAlign: "center",
          fontStyle: "italic",
          fontSize: { xs: "180px", sm: "280px", md: "460px" },
          lineHeight: 1,
          fontWeight: 700,
          letterSpacing: "-0.04em",
          color: "rgba(0, 0, 0, 0.05)",
          // fontFamily: 'Georgia, "Times New Roman", Times, serif',
          userSelect: "none",
          pointerEvents: "none",
        }}
      >
        loops
      </Typography>

      <Box
        sx={{ maxWidth: "1200px", mx: "auto", position: "relative", zIndex: 1 }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: 4,
          }}
        >
          {/* Left: small brand + copyright */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {/* <Typography
              sx={{ fontStyle: "italic", fontSize: "20px", color: "#111" }}
            >
              loops
            </Typography> */}

            {/* Socials */}
            <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
              <a
                href="https://www.instagram.com/loops.food"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon
                  sx={{
                    color: "#000",
                    fontSize: 22,
                    transition: "0.2s",
                    "&:hover": { color: "#E1306C" },
                  }}
                />
              </a>
              <a
                href="https://wa.me/60189426834"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsAppIcon
                  sx={{
                    color: "#000",
                    fontSize: 22,
                    transition: "0.2s",
                    "&:hover": { color: "#25D366" },
                  }}
                />
              </a>
              <a href="mailto:loops.food.my@gmail.com">
                <MailOutlineIcon
                  sx={{
                    color: "#000",
                    fontSize: 22,
                    transition: "0.2s",
                    "&:hover": { color: "#EA4335" },
                  }}
                />
              </a>
            </Box>

            <Typography
              variant="body2"
              sx={{ color: "#6b7280", fontSize: "14px" }}
            >
              © 2025 Loops. All rights reserved. <br />
              Loops is an independent deal aggregator. <br />
              See our{" "}
              <Link
                component={RouterLink}
                to="/terms"
                sx={{ color: "#6b7280", textDecoration: "underline" }}
              >
                Terms of Use
              </Link>{" "}
              and{" "}
              <Link
                component={RouterLink}
                to="/privacy"
                sx={{ color: "#6b7280", textDecoration: "underline" }}
              >
                Privacy Policy
              </Link>
              .
            </Typography>
          </Box>

          {/* Right: links column */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.25,
              textAlign: { xs: "left", md: "right" },
            }}
          >
            <Link
              component={RouterLink}
              to="/about"
              sx={{
                color: "#6b7280",
                textDecoration: "none",
                fontSize: "14px",
                "&:hover": { color: "#111827" },
              }}
            >
              About Loops
            </Link>
            {/* <Link
              component={RouterLink}
              to="/contact"
              sx={{
                color: "#6b7280",
                textDecoration: "none",
                fontSize: "14px",
                "&:hover": { color: "#111827" },
              }}
            >
              Contact & Support
            </Link> */}
            <Link
              component={RouterLink}
              to="/terms"
              sx={{
                color: "#6b7280",
                textDecoration: "none",
                fontSize: "14px",
                "&:hover": { color: "#111827" },
              }}
            >
              Terms of Use
            </Link>
            <Link
              component={RouterLink}
              to="/privacy"
              sx={{
                color: "#6b7280",
                textDecoration: "none",
                fontSize: "14px",
                "&:hover": { color: "#111827" },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/disclaimer"
              sx={{
                color: "#6b7280",
                textDecoration: "none",
                fontSize: "14px",
                "&:hover": { color: "#111827" },
              }}
            >
              Disclaimer
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
